export const CONFIG_BASE_URL = "../../";

export const LOCAL_BASE_URL = "https://localhost:5001/api";
export const LOCAL_SWAGGER = "https://localhost:5001/swagger/1/swagger.json";

export const DEV_BASE_URL = "https://constructiondev.consumersenergy.com/api";
export const QA_BASE_URL = "https://constructionqa.consumersenergy.com/api";
export const PROD_BASE_URL = "https://construction.consumersenergy.com/api";

export const LOOKUPS_ENDPOINT = "/lookups";
export const PROJECTS_ENDPOINT = "/projects";
export const VERSION_ENDPOINT = "/version";
export const CONFIG_ENDPOINT = "environment.config.json";
export const PACKAGES_ENDPOINT = "/packages";
export const NOTIFICATIONS_ENDPOINT = "/notifications";

/**
 * NOTE: THIS IS ONLY USED FOR TESTING. appConfig VALUES ARE
 * RETRIEVED FROM public/environmeent.config.json
 */
export const DEFAULT_APP_CONFIG = {
  env: "dev",
  apiUrl: DEV_BASE_URL,
  apimSubscriptionKey: "6c2a41bb90fd4477ab6ac1bece99349b",
};

export const QA_APP_CONFIG = {
  env: "qa",
  apiUrl: QA_BASE_URL,
  apimSubscriptionKey: "66041b74b61f4e4597016b558037e3a9",
};

export const PROD_APP_CONFIG = {
  env: "prod",
  apiUrl: PROD_BASE_URL,
  apimSubscriptionKey: "6712af0fa63e4b99b18d0f1a6413fe32",
};
